<template>
  <section class="purchase-page">
   

   <div class="banner-container">
    <img :src="bannerUrl" alt="Banner" class="banner" />
    
   </div>
   <!-- Direct HTML tag -->



    <div class="container">
      <div class="header">
        <button class="back-btn" @click="$emit('go-back')">
          <span class="material-symbols-outlined">arrow_back_ios</span>
        </button>
        <h2 class="title">Purchase Details</h2>
        <div class="progress-dots">
          <span class="active"></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div class="card">
        <div class="form-group required">
            <label for="productCode">Purchased Mattress Name<span class="requireds">*</span></label>
          <v-select
            v-model="selectedProductName"
            :options="distinctProducts"
            :get-option-label="product => product.tmp_model_name"
            :reduce="product => product.tmp_model_name"
            placeholder="Select Product Name"
            :searchable="true"
            @input="onProductNameSelected"
          ></v-select>
        </div>

        <div class="form-group required" v-if="skusForSelectedProduct.length">
        <label for="MatressCode">Mattress Code<span class="requireds">*</span></label>
        <v-select
          v-model="selectedSKU"
          :options="skuOptions"
          :get-option-label="option => option.label"
          :reduce="option => option.value"
        ></v-select>

      </div>


        <!-- Manual entry box when "Other" is selected -->
          <div class="form-group" v-if="selectedSKU === 'Other'">
            <label for="manualMatressCode">Enter Mattress Code<span class="requireds">*</span></label>
            <input
              type="text"
              v-model="manualMatressCode"
              class="form-control"
              placeholder="e.g., SPI06-7572"
              @input="validateManualCode"
            />
            <small v-if="manualCodeError" style="color: red" >{{ manualCodeError }}</small>
            
          </div>

          <div class="form-group required">
            <label for="serialNumber">Enter 8 digits Product Serial Number<span class="requireds">*</span></label>
            <input type="text" id="serialNumber" v-model="serialNumber" placeholder="Ex: ABCDEFGH" @input="validateSerial"/>
            <small v-if="serialError" style="color: red">{{ serialError }}</small>
          </div>

        <input type="hidden" v-model="quantity" />

      
        <div style="margin-left: auto;">
          <a href="#" @click.prevent="showModal = true" style="font-size: 0.9rem; color: red; text-decoration: underline;">How to find serial no?</a>
        </div>
      <div v-if="showModal" class="modal-overlay" @click.self="showModal = false">
        <div class="modal-content">
          <h4>Locate Your Product Serial Number</h4>
          <img src="@/assets/serial-number-example.png" alt="Serial Number Location" style="max-width: 100%; border-radius: 8px;"/>
          <button @click="showModal = false" class="close-btn">Close</button>
        </div>
      </div>
        <div class="form-group required">
          <label for="mobile">Enter Mobile Number<span class="requireds">*</span></label>
          <input type="tel" id="mobile" v-model="mobile" @input="validateMobile" maxlength="10"/>
          <span v-if="mobileError" style="color: red">{{ mobileError }}</span>
        </div>

        <div class="form-group">
          <button class="btn btn-primary otp-btn" @click="requestOtp" :disabled="!canRequestOtp">
            Request OTP
          </button>

        </div>
        <div v-if="otpRequested" class="otp-section">
          <div class="form-group required">
            <label for="otp">Enter OTP<span class="requireds">*</span></label>
            <input type="text" id="otp" v-model="otp" placeholder="Enter OTP" maxlength="6"/>
          <a class="resend-link" href="#" v-if="showResendLink" @click.prevent="resendOtp">Resend OTP</a>

          </div>
          <div class="validate-wrapper">
            <button class="btn btn-dark" :disabled="!otp.trim()" @click="validateOtp">
              Validate
            </button>
          </div>
        </div>
        
      <div class="footer">
      Powered by Elevatoz PVT LTD
    </div>

        
      </div>
    </div>

    
  </section>
</template>




<script>
import axios from "axios";
import Swal from "sweetalert2";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

const VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;
const VUE_OTP_BASE_URL = process.env.VUE_APP_OTP_BASE_URL;


export default {
  name: "PurchaseDetail",
  components: { vSelect },
  props: {
    initialData: { type: Object, default: () => ({}) } 
  },
  data() {
    return {
      bannerUrl: process.env.VUE_APP_BANNER_URL,
      
      mobile: this.initialData.mobile || "",
      serialNumber: this.initialData.serialNumber || "",
      quantity: this.initialData.quantity || 1,
      selectedProduct: this.initialData.selectedProduct || "",
      // products: [],
      products: [],               
      distinctProducts: [],      
      selectedProductName: null,  
      selectedSKU: null,          
      skusForSelectedProduct: [], 
      manualMatressCode: '',
      manualCodeError: '',
      serialError: "",
      quantityError: "",
      mobileError: "",
      otp: "",
      otpRequested: false,
      showResendLink: false,
      showModal: false,

     

      
    };
  },
  computed: {
    
    canRequestOtp() {
      const skuSelected = this.selectedSKU || (this.selectedProduct && this.selectedProduct.tmp_SKU_code);
      const nameSelected = this.selectedProductName || (this.selectedProduct && this.selectedProduct.name);
      const manualCodeValid = this.selectedSKU !== 'Other' || (this.manualMatressCode && !this.manualCodeError);


      // return skuSelected && nameSelected && !this.serialError && !this.quantityError && !this.mobileError;
      return skuSelected && nameSelected && !this.serialError && !this.quantityError && !this.mobileError && manualCodeValid;

    }

  


  },
  
async created() {
  await this.fetchProducts();

  if (sessionStorage.getItem("comingFromCustomerPage")) {
    const saved = sessionStorage.getItem("purchaseDetails");
    if (saved) {
      const data = JSON.parse(saved);
      this.mobile = data.mobile || "";
      this.serialNumber = data.serialNumber || "";
      this.quantity = data.quantity || 1;

      if (data.selectedProduct && this.products?.length) {
        this.selectedProduct =
          this.products.find(p => p.tmp_SKU_code === data.selectedProduct) || "";
      }
    }

    sessionStorage.removeItem("comingFromCustomerPage");
  }
},




  methods: {
     async fetchProducts() {
    try {
          const res = await axios.post(`${VUE_APP_BASE_URL}vt/centuryCenflex/getmicrositeproduct`);
        if (res.data?.data) {
            this.products = res.data.data;

            const map = new Map();
            this.products.forEach(p => {
              if (!map.has(p.tmp_model_name)) map.set(p.tmp_model_name, p);
            });
            this.distinctProducts = Array.from(map.values());
          }
        } catch (err) {
          console.error("Error fetching products:", err);
        }
      },

      onProductNameSelected(name) {
      this.skusForSelectedProduct = this.products.filter(
        p => p.tmp_model_name === name
      );

      this.skuOptions = this.skusForSelectedProduct.map(sku => ({
        label: sku.tmp_SKU_code,
        value: sku.tmp_SKU_code
      }));

      this.skuOptions.push({ label: 'Other', value: 'Other' });

      this.selectedSKU = null;
      this.manualMatressCode = '';
      this.manualCodeError = '';
    },

      

      validateManualCode() {
        const pattern = /^[A-Z]{3}[0-9]{2}-[0-9]{4}$/i; // 3 letters, 2 numbers, hyphen, 4 numbers
        if (!this.manualMatressCode) {
          this.manualCodeError = 'Mattress code is required.';
        } else if (!pattern.test(this.manualMatressCode)) {
          this.manualCodeError = 'Invalid format. Use format: AAA00-0000 (e.g., SPI06-7572).';
        } else {
          this.manualCodeError = '';
        }
      },

    async validateSerial() {
    this.serialNumber = this.serialNumber.replace(/[^a-zA-Z0-9]/g, "");
    if (this.serialNumber.length !== 8) {
      this.serialError = "Serial number must be exactly 8 alphabetic numeric characters.";
      return;
    }

    // Use manual code if 'Other' was selected, otherwise use selectedSKU
    const productCode = this.selectedSKU === 'Other'
      ? this.manualMatressCode
      : this.selectedSKU;

    if (!productCode) {
      this.serialError = "Please select or enter a valid SKU before validating serial number.";
      return;
    }

  try {
    const res = await axios.post(`${VUE_APP_BASE_URL}vt/centuryCenflex/checkserialno`, {
      serialNo: this.serialNumber,
      product_code: productCode
    });

    this.serialError =
      res.data?.code === 0
        ? ""
        : res.data?.errors?.serialNo ||
          res.data?.errors?.message ||
          res.data?.message ||
          "";
  } catch (err) {
    console.error("Serial check failed:", err);

    // When the API replies with a non-200 status, its message is in err.response.data
    const data = err.response?.data;
    this.serialError =
      data?.errors?.serialNo ||
      data?.errors?.message ||
      data?.message ||
      err.message;
  }
},
    async validateMobile() {
      this.mobile = this.mobile.replace(/[^0-9]/g, "");
      const mobileRegex = /^[6-9]\d{9}$/;

      if (!mobileRegex.test(this.mobile)) {
        this.mobileError = "Enter a valid 10-digit mobile number.";
        return;
      }
      try {
          const res = await axios.post(`${VUE_APP_BASE_URL}vt/centuryCenflex/checkmultiplepurchase`, {
            mobileNo: this.mobile,
          });
          if (res.data?.code === 0) {
            this.mobileError = "";
          } else {
            this.mobileError = res.data?.message || "Mobile number validation failed.";
          }
      } catch (err) {
              if (err.response?.data?.message) {
                this.mobileError = err.response.data.message;
              } else {
                this.mobileError = err.message || "Something went wrong while validating mobile.";
              }
            }
    },


    async requestOtp() {
      this.validateMobile();
      await this.validateSerial();
      if (!this.canRequestOtp) return;

      try {
        const res = await axios.post(`${VUE_OTP_BASE_URL}wp-json/el/v1/auth/micrositeGetOTP`, 
        { mobile: this.mobile });

        if (res.data?.code === 0) {
          Swal.fire({
            icon: "success",
            title: "OTP Sent",
            text: "OTP sent successfully!",
            confirmButtonColor: "#00688B"
          });
          this.otpRequested = true;
          this.otp = "";
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: res.data?.message || "Failed to send OTP.",
            confirmButtonColor: "#d33"
          });
        }
      } catch (err) {
        console.error(err);
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: "Error sending OTP. Try again.",
          confirmButtonColor: "#d33"
        });
      }
    },

    async resendOtp() {
      this.otp = "";
      await this.requestOtp();
    },

    async validateOtp() {
      if (!this.otp.trim()) return;

      try {
        const res = await axios.post(`${VUE_OTP_BASE_URL}/wp-json/el/v1/auth/micrositeValidateOTP`, {
          mobile: this.mobile,
          otp: this.otp
        });

        if (res.data?.code === 0) {
          this.showResendLink = false;
          Swal.fire({
            icon: "success",
            title: "OTP Verified",
            text: res.data?.response?.mobile,
            confirmButtonColor: "#00688B"
          });

          this.$emit("validated", {
             productName: this.selectedProductName,
             productSKU: this.selectedSKU,
            quantity: this.quantity,
            customerMobile: this.mobile,
            productSerialNo: this.serialNumber,
            manualMatressCode: this.manualMatressCode || null // pass manual code if any
          });
        } else {
          this.showResendLink = true;
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: res.data?.response?.otp,
            confirmButtonColor: "#d33"
          });
        }
      } catch (err) {
        this.showResendLink = true;
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: 'Incorrect OTP',
          confirmButtonColor: "#d33"
        });
      }
    }
  }
};
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.purchase-page { min-height: 100vh; display: flex; flex-direction: column; background: #f5f5f5; }
.banner img { width: 100%; height: auto; display: block; border-radius: 10px; margin-bottom: 15px; }
.container { flex: 1; padding: 20px; display: flex; flex-direction: column; align-items: center; }
.header { width: 100%; display: flex; flex-direction: column; align-items: center; margin-bottom: 40px; position: relative; }
.header .back-btn { position: absolute; left: 20px; top: 0; background: none; border: none; cursor: pointer; }
.header .title { font-size: 1.3rem; font-weight: 500; margin-bottom: 10px; display: inline; margin-top: -1PX;margin-left: -40px;}
.progress-dots { display: flex; gap: 5px; justify-content: flex-end; width: 100%; margin-top: -27px;}
.progress-dots span { width: 10px; height: 10px; background: #ccc; border-radius: 50%; display: inline-block; }
.progress-dots span.active { background: #006488; }
.card { width: 100%; max-width: 500px; background: #fff; border-radius: 12px; padding: 20px; box-shadow: 0 3px 6px rgba(0,0,0,0.1); box-sizing: border-box; display: flex; flex-direction: column; gap: 15px; }
.form-group { display: flex; flex-direction: column; margin-bottom: 15px; }
.form-group label { font-weight: 500; margin-bottom: 5px; font-size: 0.9rem; }
.form-group input, .form-group select { width: 100%; padding: 10px; border-radius: 6px; border: 1px solid #ccc; font-size: 0.95rem; box-sizing: border-box; }
.btn { color: white; background-color: green; width: 100%; padding: 12px; border: none; border-radius: 8px; font-size: 1rem; cursor: pointer; box-sizing: border-box; }
.btn-dark { background-color: green; color: white; }
.btn:disabled { background-color: #534747; cursor: not-allowed; color:white}
.validate-wrapper { display: flex; justify-content: flex-end; margin-top: 10px; }
.resend-link { color: green; font-size: 0.85rem; margin-top: 5px; cursor: pointer; text-decoration: underline; }
.select-container { position: relative; width: 100%; }
.select-container select { width: 100%; padding: 10px 35px 10px 10px; border-radius: 6px; border: 1px solid #ccc; font-size: 0.95rem; appearance: none; background: none; box-sizing: border-box; }
.select-container .select-icon { position: absolute; right: 10px; top: 50%; transform: translateY(-50%); pointer-events: none; font-size: 22px; color: gray; }
@media (max-width: 360px) {
  .purchase-page { padding: 10px; }
  .header .title { font-size: 1.1rem; }
  .card { padding: 15px; }
  .form-group input, .form-group select { padding: 8px; font-size: 0.9rem; }
  .btn { padding: 10px; font-size: 0.95rem; }
  .select-container .select-icon { font-size: 18px; }
}

.banner-container {
  max-width: 400px; 
  margin: 0 auto 15px auto;
}

.banner-container .banner {
  width: 100%;
  border-radius: 10px;
}
.vs__dropdown-toggle {
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 8px 12px;
  min-height: 42px; 
}

.vs__open-indicator {
  right: 10px !important;
  position: absolute;
}

.vs__clear {
  margin-right: 25px; 
}

.vs__selected {
  font-size: 0.95rem;
  font-weight: 500;
}

.vs__dropdown-toggle:focus {
  border-color: #00688B;
  box-shadow: 0 0 0 2px rgba(0,104,139,0.2);
}
.requireds {
  color: red;
  margin-left: 3px;
}
.otp-footer{
  align-self: center  ;
}
.footer {
  margin-top: auto; 
  font-size: 0.6rem;
  color: #888;
  text-align: center;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  max-width: 400px;
  width: 90%;
  text-align: center;
}

.close-btn {
  margin-top: 15px;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  background-color: green;
  color: white;
  cursor: pointer;
}
.text-danger {
  color: red;
  font-size: 0.85rem;
  display: block;
  margin-top: 3px;
}

</style>